import { graphql, useStaticQuery } from "gatsby"

const useGlobalCompany = () => {
  const data = useStaticQuery(graphql`
    query GlobalCompanyQuery {
      company: globals(handle: { eq: "theme" }) {
        sitename
        street
        zipcode
        city
        country
        email
        phone
      }
    }
  `)

  return data.company
}

export default useGlobalCompany
